var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBuildings = function SvgBuildings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#buildings_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 22.594h-2.297V9.805l-.1-.167a5.886 5.886 0 0 0-3.774-2.705V3.797h-2.126V0H8.297v3.797H6.17V6.98L2.579 9.646v12.948H0V24h24v-1.406Zm-9.797 0v-4.297H9.797v4.297h-2.22V5.204h8.846v17.39h-2.22Zm-3 0v-2.89h1.594v2.89h-1.594Zm-7.218-12.24 2.186-1.622v13.862H3.985v-12.24Zm10.312-8.948v2.39H9.703v-2.39h4.594Zm3.532 6.977c1 .294 1.884.935 2.468 1.82v12.39h-2.468V8.384Z",
    fill: "#A4A7B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.797 7.5h1.406v2H9.797v-2ZM12.797 7.5h1.406v2h-1.406v-2ZM9.797 11h1.406v2H9.797v-2ZM12.797 11h1.406v2h-1.406v-2ZM9.797 14.5h1.406v2H9.797v-2ZM12.797 14.5h1.406v2h-1.406v-2Z",
    fill: "#F22F42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "buildings_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBuildings;